import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { fetch } from "@insite/client-framework/ServerSideRendering";

export interface ExportTaxonomyRecommendationApiParameter extends ApiParameter {
  
}

const taxonomyRecommendationUrl = "/api/v2/taxonomyrecommendation";

export async function exportTaxonomyRecommendation(
    parameter: ExportTaxonomyRecommendationApiParameter
): Promise<Blob> {
    const response = await fetch(`${taxonomyRecommendationUrl}/export`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        throw new Error(`Export failed: ${response.statusText}`);
    }

    return response.blob();
}